import { useEffect } from "react";
import { toast } from "react-toastify";
import { getOpenSocketInstance } from "socket/openSocket.io";

export const useBranchTallySocket = ({
  tallyId,
  currentUserId,
  onScanUpdate,
  onCompleted,
}) => {
  useEffect(() => {
    if (!tallyId) return;
    const socket = getOpenSocketInstance();

    socket.on(`tally/scan-update/${tallyId}`, (data) => {
      if (data.scannedBy._id !== currentUserId) {
        const verb =
          data.type === "tallied" ? "tallied" : "scanned (not in system)";
        toast.info(`${data.scannedBy.name} ${verb} ${data.shipmentId}`, {
          autoClose: 2000,
        });
      }
      if (onScanUpdate) onScanUpdate(data);
    });

    socket.on(`tally/duplicate/${tallyId}`, (data) => {
      if (data.scannedBy._id === currentUserId) {
        toast.warning(`Already scanned: ${data.duplicates.join(", ")}`, {
          autoClose: 3000,
        });
      } else {
        toast.warning(
          `${data.scannedBy.name} tried scanning an already-scanned shipment`,
          { autoClose: 3000 },
        );
      }
    });

    socket.on(`tally/completed/${tallyId}`, (data) => {
      if (data.fullyCompleted) {
        toast.success(
          `Tally completed by ${data.completedBy.name}. Redirecting...`,
          { autoClose: 3000 },
        );
        if (onCompleted) onCompleted(data);
      } else {
        toast.info(
          `${data.completedBy.name} finished. ${data.remainingParticipants} participant(s) still scanning.`,
          { autoClose: 4000 },
        );
      }
    });

    return () => {
      socket.off(`tally/scan-update/${tallyId}`);
      socket.off(`tally/duplicate/${tallyId}`);
      socket.off(`tally/completed/${tallyId}`);
    };
  }, [tallyId, currentUserId, onCompleted, onScanUpdate]);
};
